import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      display: 'grid',
      padding: '8px 8px',
      overflow: 'auto',
    },

    root: {
      flex: 1,

      '& .MuiInputBase-input.Mui-disabled': {
        backgroundColor: palette.backgroundWhite,
      },
      '& .MuiOutlinedInput-inputAdornedStart': {
        flex: 1,
        minWidth: 100,
        padding: 0,
        marginLeft: 4,
        height: 40,
      },

      '& .MuiInputBase-root': {
        display: 'inline',
        height: 'auto',
      },
      '& .MuiChip-outlined': { marginTop: 10, marginRight: 3 },
      '& .MuiChip-root': { marginTop: 8 },
    },
  });
